import { CommonRegionBehaviorConfig } from "../common/region-config.js";

export class FilterEffectsRegionBehaviorConfig extends CommonRegionBehaviorConfig {
  static FIELDSET_LEGEND_I18N = "FXMASTER.Regions.BehaviorNames.FilterEffectRegionBehaviorName";
}

export class SuppressSceneFiltersRegionBehaviorConfig extends CommonRegionBehaviorConfig {
  static FIELDSET_LEGEND_I18N = "FXMASTER.Regions.BehaviorNames.SuppressSceneFiltersRegionBehaviorName";
}
